// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.animate-slide-in {\r\n  animation: slide-in 0.5s ease-out;\n}\n@keyframes slide-in {\n0% {\r\n    transform: translateY(-100%);\n}\n100% {\r\n    transform: translateY(0);\n}\n}\n.animate-expand {\r\n  animation: expand 1.5s ease-out;\n}\n@keyframes expand {\n0% {\r\n    height: 0;\n}\n100% {\r\n    height: 100%;\n}\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
